import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import CallBackLogin from '../views/CallBackLogin.vue'
import Welcome from '../views/Welcome'
import NoPage from '../views/404'
import Layout from "../views/Layout/Layout";
import Router from 'vue-router'
import Test from "../views/Test.vue";
import userDetails from "@/views/StatisticalAnalysis/components/userDetails.vue";
import phoneNumberDatabaseDetail from "@/views/PromotionalMarketing/components/phoneNumberDatabaseDetail.vue";
import orderProductPromotionDetail from "@/views/PromotionalMarketing/components/orderProductPromotionDetail.vue";
import MedalManagementRevisionHistory from "@/views/CommonSettings/components/MedalManagementRevisionHistory.vue"
import PointsSettingsRevisionHistory from "@/views/CommonSettings/components/PointsSettingsRevisionHistory.vue"
import PromotionSettingDetail from "@/views/PromotionalMarketing/components/PromotionSettingDetail.vue"
import SMSBulkTaskDetail from "@/views/PromotionalMarketing/components/SMSBulkTaskDetail.vue"
import statisticalAnalysis from "../views/PromotionalMarketing/components/statisticalAnalysis.vue";




Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};
const createRouter = () => new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/404', component: NoPage, name: 'NoPage',
            meta: {
                title: 'NoPage',
                requireAuth: false,
                NoTabPage: true,
                NoNeedHome: true // 添加该字段，表示不需要home模板
            },
            hidden: true
        },
        {
            path: '/',
            component: Welcome,
            name: '工作台主页面',
            iconCls: 'fa-qq',//图标样式class
            // hidden: true,
            meta: {
                title: '工作台主页面',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            }
        },
        {
            path: '/login',
            component: Login,
            name: 'login',
            iconCls: 'fa-address-card',//图标样式class
            meta: {
                title: '登录',
                NoTabPage: true,
                NoNeedHome: true // 添加该字段，表示不需要home模板
            },
            hidden: true
        },
        {
            path: '/callBackLogin',
            component: CallBackLogin,
            name: 'callBackLogin',
            iconCls: 'fa-address-card',//图标样式class
            meta: {
                title: '修改密码',
                NoTabPage: true,
                NoNeedHome: true // 添加该字段，表示不需要home模板
            },
            hidden: true
        },
        {
            path: '/qmxfwebapi/douyin',
            component: Test,
            name: 'qmxfwebapi',
            iconCls: 'fa-address-card',//图标样式class
            meta: {
                title: '页面',
                NoTabPage: true,
                NoNeedHome: true // 添加该字段，表示不需要home模板
            },
            hidden: true
        },
        {
            path: '/userDetails',
            component: userDetails,
            name: '用户明细详情',
            iconCls: 'fa-qq',//图标样式class
            meta: {
                title: '用户明细详情',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            }
        },
        {
            path: '/phoneNumberDatabaseDetail',
            component: phoneNumberDatabaseDetail,
            name: '手机号码库详情',
            iconCls: 'fa-qq',//图标样式class
            meta: {
                title: '手机号码库详情',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            }
        },
        {
            path: '/orderProductPromotionDetail',
            component: orderProductPromotionDetail,
            name: '订单详情',
            iconCls: 'fa-qq',//图标样式class
            meta: {
                title: '订单详情',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            }
        },
        {
            path: '/MedalManagementRevisionHistory',
            component: MedalManagementRevisionHistory,
            name: '勋章设置修改记录',
            iconCls: 'fa-qq',//图标样式class
            meta: {
                title: '勋章设置修改记录',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            }
        },
         {
            path: '/PointsSettingsRevisionHistory',
            component: PointsSettingsRevisionHistory,
            name: '积分设置修改记录',
            iconCls: 'fa-qq',//图标样式class
            meta: {
                title: '积分设置修改记录',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            }
        },
         {
            path: '/PromotionSettingDetail',
            component: PromotionSettingDetail,
            name: '促销活动更新记录',
            iconCls: 'fa-qq',//图标样式class
            meta: {
                title: '促销活动更新记录',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            }
        },
        {
            path: '/SMSBulkTaskDetail',
            component: SMSBulkTaskDetail,
            name: '短信群发任务详情',
            iconCls: 'fa-qq',//图标样式class
            meta: {
                title: '短信群发任务详情',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            }
        },
         {
            path: '/SMSBulkTaskDetail',
            component: SMSBulkTaskDetail,
            name: '短信群发任务详情',
            iconCls: 'fa-qq',//图标样式class
            meta: {
                title: '短信群发任务详情',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            }
        },
            {
                path: '/statisticalAnalysis',
                component: statisticalAnalysis,
                name: '统计分析',
                iconCls: 'fa-qq',//图标样式class
                meta: {
                    title: '统计分析',
                    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
                }
            },

    ]
})
const router = createRouter()
const KEEP_ALIVE_NAMES = [
  '/StatisticalAnalysis/UserStatistics',
  '/CommonSettings/MedalManagement'
];
export function filterAsyncRouter(asyncRouterMap) {
    //注意这里的 asyncRouterMap 是一个数组
    const accessedRouters = asyncRouterMap.filter(route => {
        if (route.path && !route.isButton) {
            if (route.path === '/' || route.path === '-') {//Layout组件特殊处理
                route.component = Layout
            } else {
                try {
                    route.component = _import(route.path.replace('/:id', ''))
                } catch (e) {
                    try {
                        route.component = () => import('@/views' + route.path.replace('/:id', '') + '.vue');
                    } catch (error) {
                        console.info('%c 当前路由 ' + route.path.replace('/:id', '') + '.vue 不存在，因此如法导入组件，请检查接口数据和组件是否匹配，并重新登录，清空缓存!', "color:red")
                    }
                }
            }
        }
        
        // 加入是否缓存路由标志keepAlive
        route.meta = route.meta || {};
        const shouldKeepAlive =
            KEEP_ALIVE_NAMES.includes(route.path)

        if (shouldKeepAlive) {
            route.meta.keepAlive = true;
            console.log('✅ [Router] 自动注入 keepAlive:', route.name || route.path);
        }

        if (route.children && route.children.length && !route.isButton) {
            route.children = filterAsyncRouter(route.children)
        }
        return true
    })
    return accessedRouters
}
export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // the relevant part
}
function filterRoutes(routes) {
    return routes.filter(route => {
        if (route.isButton) return false;
        if (route.children && route.children.length > 0) {
            route.children = filterRoutes(route.children);
        }
        return true;
    });
}

router.$addRoutes = (params) => {
    const filteredRoutes = filterRoutes(params);
    router.addRoutes(filteredRoutes);
};

export default router
